import { defineStore } from "pinia";

const usePublicStore = defineStore("publicStore", {
    state: () => ({
        modalOpen: null,
        sidebarOpen: null,
    }),

    actions: {
        // Modal
        isModalOpen(name) {
            return this[name];
        },

        openModal(name) {
            this.modalOpen = name;
        },

        closeModal() {
            this.modalOpen = null;
        },

        // Nav
        isSidebarOpen(name) {
            return this[name];
        },

        toggleSidebar(name) {
            if (this.sidebarOpen === name) {
                this.sidebarOpen = null;
            } else {
                this.sidebarOpen = name;
            }
        },

        openSidebar(name) {
            this.sidebarOpen = name;
        },

        closeSidebar() {
            this.sidebarOpen = null;
        },
    },
});

export default usePublicStore;
